import React from 'react';
import './HindiPhoneticTyping.css';

const HindiPhoneticTyping = ({
  input,
  setInput,
  started,
  setStarted,
  selectedParagraph,
  calculateMetrics,
  handleTestComplete,
  setKeyCount,
  textareaRef,
  paragraphRef
}) => {

  const handleChange = (e) => {
    let value = e.target.value;

    if (!started && value.length > 0) {
      document.documentElement.requestFullscreen().catch(() => {});
      setStarted(true);
    }

    // ❌ NO conversion here (IMPORTANT)
    if (value.length > selectedParagraph.length) return;

    setInput(value);
    calculateMetrics(value);

    if (paragraphRef.current) {
      const progress = value.length / selectedParagraph.length;
      const maxScroll =
        paragraphRef.current.scrollHeight -
        paragraphRef.current.clientHeight;

      paragraphRef.current.scrollTop = maxScroll * progress;
    }

    if (value.length === selectedParagraph.length) {
      handleTestComplete();
    }
  };

  const handleKeyDown = (e) => {
    if (e.ctrlKey || e.metaKey) e.preventDefault();
    if (["ArrowLeft", "ArrowUp", "Home"].includes(e.key)) e.preventDefault();

    if (e.key === "Backspace" && input.length === 0) {
      e.preventDefault();
    }

    if (
      e.key.length === 1 ||
      e.key === "Backspace" ||
      e.key === "Enter" ||
      e.key === " "
    ) {
      setKeyCount(prev => prev + 1);
    }
  };

  return (
    <textarea
      ref={textareaRef}
      value={input}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      placeholder={started ? "Continue typing..." : "Start typing here..."}
      className="typing-inputphonetic"
      spellCheck={false}
      onPaste={(e) => e.preventDefault()}
      onCopy={(e) => e.preventDefault()}
      onCut={(e) => e.preventDefault()}
      onContextMenu={(e) => e.preventDefault()}
      autoComplete="off"
      autoCorrect="off"
      autoCapitalize="off"
    />
  );
};

export default HindiPhoneticTyping;